import { TSelector } from '../../../redux/rootSelectors';
import { IContainerDetail } from '../reducer';

export const selectorContainerDetail: TSelector<
  IContainerDetail['tempDetail']
> = ({ containerDetail }) => containerDetail.tempDetail;
